var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.componentSwitch,{tag:"component",staticClass:"ws-card stronger-selector",class:[
    `spacing-${_vm.spacing}`,
    `spacing-tablet-${_vm.spacingTablet || _vm.spacing}`,
    `spacing-mobile-${_vm.spacingMobile || _vm.spacingTablet || _vm.spacing}`,
  ]},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }